<template>
  <b-card no-body>
    <loader v-if="loading" />
    <b-tabs v-else pills card>
      <b-tab
        :title="`${dataset.place} ${dataset.service} ${dataset.label} (${dataset.unit})`"
        active
        v-for="dataset in dataCollection"
        :key="dataset.var_item_id"
      >
        <b-card-text>
          <log-table :dataset="dataset" />
        </b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import DatasetLoadMixin from '@/components/logging/DatasetLoadMixin';
import LogTable from '@/components/logging/LogTable';
import Loader from '@/components/utils/Loader';

export default {
  name: 'LogTableView',
  mixins: [
    BreadcrumbsManager,
    DatasetLoadMixin,
  ],
  props: {
    varsIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    this.setBreadcrumbs([
      {
        text: `${this.$t('charts')} / ${this.$t('logging')}`,
        to: {
          name: 'logging-default',
        },
      },
      {
        text: `${this.$t('table-view')}`,
      },
    ]);
  },
  components: { LogTable, Loader },
};
</script>

<style scoped>

</style>
